import React, { useState, useEffect } from 'react';
import { FadeLoader } from 'react-spinners';
//import { useDispatch, useSelector } from 'react-redux';
//import { setLoading } from '../../redux/loaderAction';

function Loader({ isLoading }) {
  //const dispatch = useDispatch();
  //const loading = useSelector((state) => state.loader.loading);
  if(!isLoading){
    return null;
  }
    //if(loading){
        return (
            <div   style={{
              display: (isLoading ? 'block !important' : 'none !important'),
              display: 'flex',
              justifyContent: 'center', // Centers horizontally
              alignItems: 'center',     // Centers vertically
              position: 'fixed',      // Allows positioning relative to the nearest positioned ancestor
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.8)' // Optional: adds a background for better visibility
            }}>
              <FadeLoader color="#fff" loading={true} />
            </div>
          );
    //}
    return null;
}

export default Loader